"use strict";
exports.__esModule = true;
exports.LANGUAGE_MAP = void 0;
exports.LANGUAGE_MAP = {
    'en-US': 'en',
    'tr-TR': 'tr',
    'az-AZ': 'az',
    'kz-KK': 'kk',
    'kk-KZ': 'ru',
    'uz-UZ': 'uz',
    'hi-IN': 'hi',
    'hy-AM': 'hy',
    'de-DE': 'de',
    'es-ES': 'es',
    'fr-FR': 'fr',
    'it-IT': 'it',
    'pl-PL': 'pl',
    'pt-PT': 'pt',
    'ru-RU': 'ru',
    'zh-HK': 'zh',
    'zh-CH': 'zh',
    'el-GR': 'el',
    'cs-CZ': 'cs',
    'da-DK': 'da',
    'fi-FI': 'fi',
    'bg-BG': 'bg',
    'sv-SW': 'sv',
    'lt-LT': 'lt',
    'ar-SA': 'ar',
    'ar-AE': 'ar',
    'vi-VN': 'vi',
    'uk-UA': 'uk',
    'ko-KR': 'ko',
    'he-IL': 'he',
    'jp-JA': 'ja',
    'sv-SE': 'sv'
};
//# sourceMappingURL=language-map.constant.js.map